module.exports = __webpack_public_path__ + "img/rail.992a8de9.png";